// Email addresses to try, in order, when finding a user by email (sharing a
// guide). Sign-in stores emails in lowercase, so "TestUser3@gmail.com"
// typed as-is found nobody (2026-10-24); the lowercase form goes first, and
// the address as typed second, for any older account stored differently.
// Identical in andiamo-web and andiamo-places.
export const emailCandidates = (typed) => {
  const email = String(typed || "").trim();
  if (email === "") return [];
  const lower = email.toLowerCase();
  return lower === email ? [email] : [lower, email];
};
